module.exports = __webpack_public_path__ + "img/appAsset--customer-ax.826e1725.svg";